<template>
  <div>
    <form @submit.prevent="checkValidation()" autocomplete="off">
      <label>
        {{ $t("labels.showing") }} {{ form_elements.length }}
        {{ $t("labels.images") }}
      </label>
      <div class="vx-row mb-4 mt-4">
        <div
          v-for="(element, index) in form_elements"
          :key="index"
          class="vx-col sm: w-full md:w-1/2 lg:w-1/3 xl:w-1/4 general-image-card pb-6 flex"
        >
          <vx-card>
            <div class="image_upload">
              <div class="flex justify-between">
                <div
                  class="font-bold self-center"
                  v-if="
                    $store.state.userInfo.type === 'CN' ||
                    $store.state.userInfo.type === 'A'
                  "
                >
                  <p v-if="index==0" class="text-success p-0 m-0 font-normal">Cover Image</p>
                  {{ $t("labels.add_image_description") }}
                </div>
                <vs-button
                  v-if="
                    $store.state.userInfo.type === 'CN' ||
                    $store.state.userInfo.type === 'A'
                  "
                  class="shadow-lg"
                  size="small"
                  color="danger"
                  @click="removeElement(index)"
                  >X</vs-button
                >
              </div>
              ​
              <div v-if="!element.url" class>
                <input
                  v-validate="'required'"
                  name="url"
                  type="file"
                  accept=".jpg, .png, .jpeg"
                  class="vs-inputx vs-input--input normal hasValue mt-1 work"
                  v-on:change="uploadImageSuccess($event, index)"
                  multiple
                />
              </div>

              <div class="flex justify-center w-full" v-if="element.url">
                <div class="upload-img polaroid">
                  <a :href="element.url" target="_blank">
                    <img :src="element.url" alt="Image" />
                  </a>
                </div>

                <vs-button
                  color="danger"
                  type="flat"
                  v-if="
                    $store.state.userInfo.type === 'CN' ||
                    $store.state.userInfo.type === 'A'
                  "
                  :title="$t('labels.remove_image')"
                  class="mr-4 mt-1 float-right ml-2 cancel-btn"
                  icon-pack="feather"
                  icon="icon-x"
                  v-model="cancel"
                  @click.prevent="clearFileName(index)"
                  id="save_as_draft"
                ></vs-button>
              </div>
              ​
              <div
                class="mb-4 upload-user"
                v-if="$store.state.userInfo.type === 'A' && element.uploader"
              >
                <span>
                  {{ $t("labels.uploaded_by") }}
                  <span class="font-bold">{{ element.uploader.name }}</span>
                </span>
              </div>
              <div class="justify-center">
                <vs-textarea
                  name="role_description"
                  class="image-description"
                  placeholder="Description"
                  v-model="element.description"
                />​
              </div>
              <!-- <label>{{ $t("labels.section") }}</label>
            <vs-select v-model="element.section">
              <vs-select-item
                v-for="(item, index) in sections"
                :key="index"
                :value="item.value"
                :text="item.text"
              />
            </vs-select>-->
              <div class="vx-col sm: w-full">
                <label>{{ $t("labels.section") }}</label>
                <v-select
                  :options="sections"
                  name="section"
                  v-model="element.section_id"
                  :reduce="(sections) => sections.id"
                  label="name"
                  @input="(section) => updateSubsection(element, section)"
                  :value="$store.myValue"
                  class="sec_drop mt-1"
                />
                <span class="text-danger text-sm">
                  {{ errors.first("section") }}
                </span>
              </div>
              <div class="vx-col sm: w-full sm: pl-0 mt-6">
                <label>{{ $t("labels.sub_section") }}</label>
                <v-select
                  name="sub_section"
                  v-model="element.sub_section_id"
                  :options="element.sub_section_drop"
                  :reduce="(sub_section_drop) => sub_section_drop.id"
                  label="name"
                  class="sec_drop mt-1"
                />
                <span class="text-danger text-sm">
                  {{ errors.first("sub_section") }}
                </span>
              </div>
            </div>
          </vx-card>
        </div>
        <div
          class="vx-col sm: w-full md:w-1/3 design-div"
          @click="addElement"
          v-if="!form_elements.some((element) => element.url === '')"
        >
          <div class="design-btn" :title="$t('labels.add_new_image')">
            <feather-icon
              icon="PlusIcon"
              class="cursor-pointer mt-1 sm:mr-6 mr-2"
            ></feather-icon>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button
            class="login-btn float-right"
            color="warning"
            :disabled="button_loading"
            id="save-answer"
            button="submit"
            >{{ $t("labels.save_data") }}</vs-button
          >
        </div>
      </div>
    </form>
  </div>
</template>
​
<script>
import VueUploadMultipleImage from "vue-upload-multiple-image";

export default {
  components: {
    VueUploadMultipleImage,
  },
  data() {
    return {
      id: this.$route.params.id,
      images: [],
      sub_section: null,
      sub_sections: [],
      selecetd_section: "",
      sections: [],
      cancel: "",
      form_elements: [
        {
          description: "",
          url: "",
          uploader: "",
          section_id: "",
          service_id: "",
          consultant_id: "",
          sub_section_drop: [],
        },
      ],
    };
  },
  props: ["consultantId", "serviceId"],
  async mounted() {
    await this.getProject();
    await this.getSections();
  },
  methods: {
    checkValidation() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.sendImages();
        }
      });
    },
    updateSubsection(element, section) {
      this.sections.forEach((el) => {
        if (el.id == section) {
          element.sub_section_drop = el.children;
        }
      });
      //fist clear selected subsection and its dropdown array
      element.sub_section_id = null;
      element.sub_section_drop = [];
      //set current v-select value as a selected_section
      this.selected_section = section;

      // get subsections for selected section
      let sections = this.sections;
      var selected_sections = sections.filter(function (el) {
        return el.id == section;
      });
      this.sections.forEach((el) => {
        if (el.id == section) {
          element.sub_section_drop = el.children;
        }
      });
    },
    async sendImages() {
      let input = {
        images: this.form_elements,
      };
      let url = "/projects/images/" + this.$route.params.id;
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#save-answer",
        true
      );
      if (response) {
        await this.getProject();
        await this.getSections();
      }
    },
    async getProject() {
      this.$vs.loading();
      let response = await this.getHTTPGetResponse(
        "/projects/get/" + this.$route.params.id
      );
      if (response) {
        let data = response.data;
        let project = data.project;
        let images = data.project.images;
        let serviceImages = [];
        images.forEach((el) => {
          if (
            el.consultant_id === this.consultantId &&
            el.service_id === this.serviceId
          ) {
            serviceImages.push(el);
          }
        });
        this.form_elements = serviceImages;
      }
      this.$vs.loading.close();
    },
    addElement() {
      this.form_elements.push({
        description: "",
        url: "",
        section_id: "",
        sub_section_id: "",
        service_id: this.serviceId,
        consultant_id: this.consultantId,
      });
    },
    removeElement(index) {
      this.form_elements.splice(index, 1);
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    async uploadImageSuccess(event, index) {
      var element = this.form_elements[index];
      var fileData = event.target.files;
      for (var i = 0; i < fileData.length; i++) {
        var input = new FormData();
        input.append("directory", "listing");
        input.append("attachment", event.target.files[i]);
        var response = await this.axios.post("s3/upload", input);
        if (response) {
          let data = response.data.data;
          var new_element = {
            ...element,
            url: data.url,
          };
          this.form_elements.splice(index + i, i == 0 ? 1 : 0, new_element);

          this.$vs.notify({
            title: "Success.",
            text: response.data.message,
            color: "success",
            position: "top-right",
          });
        }
      }
    },
    getFileName(url) {
      var filename = url.substring(url.lastIndexOf("/") + 1);
      return filename;
    },
    clearFileName(index) {
      this.form_elements[index].url = "";
      // this.form_elements[index].description = "";
    },
    // API Integration for section listing
    async getSections() {
      let input = {
        only_parents: true,
        with_children: true,
      };
      let response = await this.getHTTPPostResponse("/sections/list", input);
      if (response) {
        let sections = response.data.sections;

        this.sections = sections;
        await this.form_elements.forEach((element) => {
          this.sections.forEach((el) => {
            if (el.id == element.section_id) {
              element.sub_section_drop = el.children;
            }
          });
        });
      }
    },
  },
};
</script>
<style scoped>
.upload-img img {
  border-radius: 3px;
  width: 100%;
  height: 240px;
}

.upload-img,
img:hover {
  box-shadow: 0 0 2px 1px rgba(0, 140, 186, 0.5);
}
div.polaroid {
  width: 100%;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 3px;
  position: relative;
}
.cancel-btn {
  position: absolute;
  right: 10px;
}
.vs-con-textarea {
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
  border-radius: 5px;
  /* margin-left: 23px; */
  /* background: rgba(var(--vs-dark), 1) !important; */
  /* width: 81%; */
  margin-bottom: 0 !important;
  box-shadow: none !important;
}
label {
  font-size: 18.48px;
  font-weight: 600;
  color: rgba(var(--vs-dark), 1) !important;
}
.design-btn {
  width: 180px;
  height: 180px;
  border: 1px dashed #c5c5c5;
  cursor: pointer;
  margin: 0;
}
.design-btn .feather-icon {
  top: 25.4%;
  left: 26.8%;
}
.design-btn .feather-icon svg {
  width: 80px;
  stroke: #c5c5c5;
  height: 80px;
}
.upload-user {
  font-size: 16px;
}
.image_upload {
  padding: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
